import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Typography } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  BankOutlined,
} from '@ant-design/icons';
import '../../styles/colors.css';

const { Title, Text, Paragraph } = Typography;

const LoginHub: React.FC = () => {
  const items = [
    { to: '/login/mentee', label: 'Mentee Girişi', sub: 'Kariyer ve eğitim fırsatları', icon: <UserOutlined /> },
    { to: '/login/mentor', label: 'Mentor Girişi', sub: 'Danışmanlık ve eğitim yönetimi', icon: <TeamOutlined /> },
    { to: '/login/company', label: 'Kurumsal Giriş', sub: 'İş ilanları ve aday süreçleri', icon: <BankOutlined /> },
  ];

  return (
    <div
      className="auth-page-shell"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 720, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <Title
            level={2}
            style={{
              color: 'var(--text-primary)',
              marginBottom: 10,
              letterSpacing: '-0.02em',
              fontWeight: 700,
            }}
          >
            Menteem — Giriş
          </Title>
          <Paragraph
            type="secondary"
            style={{
              maxWidth: 520,
              margin: '0 auto 10px',
              fontSize: 15,
              lineHeight: 1.65,
              color: 'var(--text-secondary)',
            }}
          >
            Hesap türünüze göre giriş yapın; her rol için ayrı kayıt gerekir.
          </Paragraph>
          <Text type="secondary" style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>
            Başka bir rolden hesabın yoksa önce o hesap türüyle kayıt ol, sonra aynı sayfadan tekrar giriş yapabilirsin.
          </Text>
        </div>
        <Row gutter={[18, 18]}>
          {items.map((item) => (
            <Col xs={24} sm={12} key={item.to}>
              <Link to={item.to} style={{ textDecoration: 'none', color: 'inherit', display: 'block', height: '100%' }}>
                <Card hoverable className="app-content-card login-hub-role-card" styles={{ body: { padding: '22px 20px' } }} style={{ height: '100%' }}>
                  <div className="login-hub-role-icon">{item.icon}</div>
                  <Title level={4} style={{ marginBottom: 6, color: 'var(--text-primary)', fontWeight: 600 }}>
                    {item.label}
                  </Title>
                  <Text type="secondary" style={{ fontSize: 14 }}>{item.sub}</Text>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
        <div style={{ textAlign: 'center', marginTop: 28 }}>
          <Text type="secondary" style={{ fontSize: 13 }}>Ana sayfaya dön: </Text>
          <Link to="/" style={{ color: 'var(--primary-600)', fontWeight: 600 }}>Menteem</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginHub;
